export const temp = {
  intro: {
    title: 'Introduction title placeholder',
    body: ['Introduction body placeholder'],
  },
};
